export default "__VITE_ASSET__43869afd__"